import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import React, { CSSProperties, PropsWithChildren } from 'react';
import './converation-update-modal.scss';
import { ReactComponent as CloseIcon } from '@zonofi/svg-icons/close.svg';

interface ConversationUpdateModalProps {
  open: boolean;
  onClose: () => void;
  header: string;
  customerName: string;
  style?: CSSProperties;
}

type Props = PropsWithChildren<ConversationUpdateModalProps>;

export const ConversationUpdateModal: React.FC<Props> = ({
  open,
  onClose,
  header,
  customerName,
  children,
  style,
}) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      PaperProps={{
        className: 'conversation-update-modal font-regular',
        style: { background: '#ecf0f5', maxHeight: '90dvh', ...style },
      }}
    >
      <div className="conversation-update-modal-header">
        <div className="header-content">
          <div className="heading font-semibold">{header}</div>
          <div className="sub-heading">{customerName}</div>
        </div>
        <div className="close-btn" onClick={onClose}>
          <CloseIcon fill="#595959" />
        </div>
      </div>
      {children}
    </SwipeableDrawer>
  );
};
